module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6UWvH"))).then(() => module.bundle.root('1iHdE'));